module.exports = __webpack_public_path__ + "static/img/Gilles_Vermot_Desroches_2017.8fa5d4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/Gilles_Vermot_Desroches_2017.jpg
// module id = ln8l
// module chunks = 0